import { PawPrint, Send } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 10: "Wyślij 3 osobom" - prosty, bezpośredni apel z liczbą
 */
export const InstagramStoryShare10 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Big number */}
        <div
          style={{
            fontSize: "200px",
            fontWeight: 800,
            color: "#2D5A3D",
            lineHeight: 1,
            marginBottom: "16px",
          }}
        >
          3
        </div>

        <p
          style={{
            fontSize: "56px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 20px",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          osoby
        </p>

        {/* Divider */}
        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", margin: "24px 0 40px" }} />

        <p
          style={{
            fontSize: "48px",
            fontWeight: 700,
            color: "#3D6B52",
            margin: "0 0 56px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Wyślij ten link 3 znajomym,
          <br />
          którzy kochają zwierzęta.
          <br />
          To wystarczy.
        </p>

        {/* Card */}
        <div
          style={{
            background: "rgba(255,255,255,0.95)",
            borderRadius: "32px",
            padding: "40px 56px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            marginBottom: "56px",
          }}
        >
          <p
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Nie trzeba pieniędzy.
            <br />
            Nie trzeba czasu.
            <br />
            Wystarczy jedno kliknięcie 💚
          </p>
        </div>

        {/* CTA */}
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "24px 56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Send style={{ width: "30px", height: "30px", color: "#FFFFFF" }} />
          <p style={{ fontSize: "36px", fontWeight: 700, color: "#FFFFFF", margin: 0 }}>
            Prześlij dalej
          </p>
        </div>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
